// Reads corpus statistics injected into window.Aedu.SiteStats by the server
// (see AcademiaEdu#as_json). SSR-safe: when the global is unavailable (server-
// side render or tests) it returns DEFAULTS — which is GENERATED from
// AcademiaEdu.as_json (run `rake site_stats:generate_js_defaults`). Ruby is the
// single source of truth; spec/lib/site_stats_defaults_spec.rb fails CI if the
// generated file drifts.
import DEFAULTS from './siteStatsDefaults.generated.json';

interface SiteStats {
  monthly_visitor_count_in_millions: number;
  paper_count_in_millions: number;
  scanned_paper_count_in_millions: number;
  user_count_in_millions: number;
}

// Compile-time check that the generated payload still matches the expected
// shape (a future as_json key removal would surface here as a type error).
const defaults: SiteStats = DEFAULTS;

function siteStats(): SiteStats {
  if (typeof window === 'undefined') return defaults;
  const aedu = window.Aedu as
    | (typeof window.Aedu & { SiteStats?: SiteStats })
    | undefined;
  return (aedu && aedu.SiteStats) || defaults;
}

export function paperCountInMillions(): number {
  return siteStats().paper_count_in_millions;
}

export function scannedPaperCountInMillions(): number {
  return siteStats().scanned_paper_count_in_millions;
}

export function userCountInMillions(): number {
  return siteStats().user_count_in_millions;
}
